import React from 'react';
import { Chip, Typography, IconButton } from '@mui/material';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { TYPES_COMMANDES } from 'Shared/constants/order';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export const mapOrderStatus = {
  NON_ASSIGNEE: { label: 'Non assignée', class: 'NotAssignedStatus' },
  EN_ATTENTE_PICKAGE: { label: 'En attente de pickage', class: 'awaitingPicking' },
  EN_ATTENTE_VALIDATION: { label: 'Validation', class: 'awaitingValidation' },
  EN_COURS_PICKAGE: { label: 'En cours', class: 'pickingInprogress' },
  CLOTUREE: { label: 'Clôturée', class: 'closed' },
  BL_GENERE: { label: 'BL généré', class: 'invoiced' },
  MANQUE: { label: 'Manque', class: 'manque' },
  STOCK: { label: 'Stock', class: 'stock' },
  IMPRIME: { label: 'Imprimé', class: 'closed' },
};

const getTypeName = (typeCode) => {
  const item = TYPES_COMMANDES.find((type) => type.id === typeCode);
  return item ? item.label : '-';
};

const TitleStyle = {
  fontSize: '12px',
  fontWeight: 500,
  borderBottom: 'none',
  textTransform: 'uppercase',
  background: '#e4e7ea',
  font: 'normal normal 600 10px Montserrat',
  letterSpacing: 0,
  color: '#707070',
  padding: '12px 8px',
};
const defaultColumnStyle = {
  font: 'normal normal 600 12px Montserrat',
  letterSpacing: 0,
  color: '#38485C',
};

export const downloadFromLink = (url, filename) => (event) => {
  event.stopPropagation();
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    })
    .catch(() => {
      toast.error('Erreur Système');
    });
};
export const columns = [
  /* {
    id: 'printed',
    label: '',
    style: TitleStyle,
    render: ({ value }) => (
      <>
        {value && <DoneIcon style={{ color: 'green' }} />}
        {!value && <NotInterestedIcon />}
      </>
    ),
  }, */
  {
    id: 'reference',
    label: 'N° DOCUMENT',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>{value}</Typography>
    ),
  },
  {
    id: 'date',
    label: 'DATE',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography sx={{ ...defaultColumnStyle, mr: '9px' }} display="inline">
        {format(new Date(value), 'dd/MM/yyy')}
      </Typography>
    ),
  },
  {
    id: 'client',
    label: 'Client',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'clientCity',
    label: 'Ville client',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  /* {
    id: 'clientIce',
    label: 'ICE Client',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  }, */
  {
    id: 'type',
    label: 'Type',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{getTypeName(value)}</Typography>,
  },
  {
    id: 'paymentMode',
    label: 'CONDITION DE LIVRAISON',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'expedition',
    label: 'Expedition',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'amount',
    label: 'Montant',
    style: TitleStyle,
    render: ({ value }) => <Typography sx={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'status',
    label: 'Status',
    style: TitleStyle,
    render: ({ value, row }) => (
      <>
        {mapOrderStatus[value] ? (
          <Chip
            className={row.statusClass}
            style={{ height: 20 }}
            label={mapOrderStatus[value]?.label}
          />
        ) : '-'}
      </>
    ),
  },
  {
    id: 'action',
    label: '',
    style: TitleStyle,
    render: ({ row }) => (
      <IconButton onClick={row.onHandleActions(row)}>
        <MoreHorizIcon />
      </IconButton>
    ),
  },
];

/*

      <Box style={{ display: 'flex', columnGap: '5px' }}>
        {[3].includes(row.type) && (
        <Tooltip title="Télécharger le bon de livraison">
          <Button
            variant="contained"
            color="primary"
            style={{ minWidth: '40px', padding: '4px 0' }}
            size="small"
            onClick={row.handleDownloadBl}
          >
            <GetAppIcon />
          </Button>
        </Tooltip>
        )}
        {[6, 7].includes(row.type) && (
        <Tooltip title="Télécharger la facture">
          <Button
            variant="contained"
            color="primary"
            style={{ minWidth: '40px', padding: '4px 0' }}
            size="small"
            onClick={row.handleInvoice}
          >
            <GetAppIcon />
          </Button>
        </Tooltip>
        )}
        {row.numExpedition && !['LUI MEME BOUSK', 'LUI MEME DERB OMAR', 'CAR']
          .includes(row.expedition) && (
        <ButtonGroup size="small" variant="contained">
          <Tooltip title="Télécharger la déclaration d'expédition">
            <Button
              variant="contained"
              color="primary"
              style={{ minWidth: '40px', padding: '4px 0' }}
              size="small"
              onClick={downloadFromLink(row.numExpedition, row.reference)}
            >
              <GetAppIcon />
            </Button>
          </Tooltip>
          <Tooltip title="Aperçu la déclaration d'expédition">
            <Button
              variant="contained"
              color="primary"
              style={{ minWidth: '40px', padding: '4px 0' }}
              size="small"
              onClick={row.handleDisplayCoord1(row.numExpedition)}
            >
              <VisibilityIcon />
            </Button>
          </Tooltip>
        </ButtonGroup>
        )}
      </Box>
*/
